import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyChoose from './components/WhyChoose';
import Inventory from './components/Inventory';
import Locations from './components/Locations';
import Signup from './components/Signup';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Simple routing based on hash
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash === 'privacy-policy') {
        setCurrentPage('privacy');
      } else {
        setCurrentPage('home');
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Scroll to top when page changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  return (
    <div className="app">
      <Header />
      <main>
        {currentPage === 'privacy' ? (
          <PrivacyPolicy />
        ) : (
          <>
            <Hero />
            <WhyChoose />
            <Inventory />
            <Locations />
            <Signup />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default App;